import { NgClass, NgIf } from '@angular/common';
import { Component, HostListener, inject, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';
import { Router } from '@angular/router';
import { Constants } from '../../shared/utils/constants';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgIf],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  public isLoggedIn: boolean = true;
  loaderService = inject(LoaderService)
  ngOnInit() {
    this.loaderService.loginStatus.subscribe((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        this.isLoggedIn = true;
      }
      else {
        this.isLoggedIn = false;
      }

    });

  }
}
